<div class="content">
  <h4>Oh oh... Looks like you're lost 😕</h4>
  <p>Click <a href="/">me</a> to get home</p>
</div>
